// extracted by mini-css-extract-plugin
export var carrierIcon = "_yl-0";
export var carrierLogo = "_yl-1";
export var detailsSection = "_yl-2";